import { makeAutoObservable } from 'mobx';
import { CheckoutInfo } from '../interfaces/checkoutInfo';
import { resetAllStore } from '../../shared/stores/resetAllStore';
import { checkoutService } from '../services/checkoutService';
import {
  SUBSCRIPTION,
  SubscriptionType,
  SubscriptionTypeFlags,
} from '../../shared/constants/user-info/subscription';
import { getFlagsObject } from '../../shared/utils/sortingAndGroupingUtil';
import {
  BILLING_PERIOD_TYPE,
  BillingPeriodType,
  BillingPeriodTypeFlags,
} from '../constants/billingPeriodType';

class CheckoutStore {
  checkoutInfo: CheckoutInfo | null = null;
  subscriptionTypeFlags: SubscriptionTypeFlags = {};
  billingPeriodTypeFlags: BillingPeriodTypeFlags = {};

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  setDefaultValues() {
    this.checkoutInfo = null;
  }

  async createSubscription(entityId: number, email: string, subscriptionId: number) {
    const response = await checkoutService.createSubscription(
      entityId,
      email,
      subscriptionId,
    );

    this.setCheckoutInfo(response);
    this.setSubscriptionTypeFlags(response.subscription.subscriptionType);
    this.setBillingPeriodTypeFlags(response.subscription.billingPeriodType);
  }

  async createScanIqSubscription(entityId: number, subscriptionId: number) {
    const response = await checkoutService.createScanIqSubscription(
      entityId,
      subscriptionId,
    );

    this.setCheckoutInfo(response);
    this.setSubscriptionTypeFlags(response.subscription.subscriptionType);
    this.setBillingPeriodTypeFlags(response.subscription.billingPeriodType);
  }

  private setCheckoutInfo(checkoutInfo: CheckoutInfo) {
    this.checkoutInfo = checkoutInfo;
  }

  private setSubscriptionTypeFlags(subscriptionType: SubscriptionType) {
    const subscriptionTypeFlags = getFlagsObject(SUBSCRIPTION, [subscriptionType]);

    this.subscriptionTypeFlags = subscriptionTypeFlags;
  }

  private setBillingPeriodTypeFlags(billingPeriodType: BillingPeriodType) {
    const billingPeriodTypeFlags = getFlagsObject(BILLING_PERIOD_TYPE, [
      billingPeriodType,
    ]);

    this.billingPeriodTypeFlags = billingPeriodTypeFlags;
  }
}

const checkoutStore = new CheckoutStore();
resetAllStore.addResetMethod(checkoutStore.setDefaultValues);

export { checkoutStore, CheckoutStore };
